import React from 'react';

import { BoldText, ClauseText } from '../ContractText';

type MortgageFinancingProps = {
  financingCommittmentDate?: string;
  financingLoanProgram?: string;
  loanAmount?: number;
  loanTerm?: number;
  marketInterestRate?: number;
  lenderName?: string;
  lenderAddress?: string;
  lenderNMLS?: string;
  loanOfficerName?: string;
  loanOfficerPhone?: string;
  loanOfficerEmail?: string;
  loanOfficerNMLS?: string;
};

const MortgageFinancing = ({
  financingCommittmentDate,
  financingLoanProgram,
  loanAmount,
  loanTerm,
  marketInterestRate,
  lenderName,
  lenderAddress,
  lenderNMLS,
  loanOfficerName,
  loanOfficerPhone,
  loanOfficerEmail,
  loanOfficerNMLS,
}: MortgageFinancingProps) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Mortgage Financing
      </h2>
      <div className="mb-8">
        <ol className="list-decimal ml-6 space-y-1">
          <li>
            This sale is contingent upon Buyer obtaining mortgage financing
            according to the terms outlined below. Upon receiving documentation
            demonstrating the mortgage lender’s approval, whether conditional or
            outright, of Buyer’s mortgage application(s) according to the
            following terms, Buyer will promptly deliver a copy of the
            documentation to Seller, but in any case no later than{' '}
            {financingCommittmentDate}.
          </li>
          <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
            <li>Proposed First Mortgage</li>
            <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
              <li>
                The loan program selected for this purchase is{' '}
                <ClauseText>{financingLoanProgram}</ClauseText>.
              </li>
              <li>
                The loan amount is <ClauseText>{loanAmount}</ClauseText>.
              </li>
              <li>
                The loan term is <ClauseText>{loanTerm} years</ClauseText>.
              </li>
              <li>
                The market interest rate is{' '}
                <ClauseText>{marketInterestRate}%</ClauseText>.
              </li>
              <li>
                The lender for this transaction is{' '}
                <ClauseText>{lenderName}</ClauseText>.
              </li>
              <li>
                The lender address is <ClauseText>{lenderAddress}</ClauseText>.
              </li>
              <li>
                The lender NMLS ID is <ClauseText>{lenderNMLS}</ClauseText>
              </li>
              <li>
                The loan officer for this transaction is{' '}
                <ClauseText>{loanOfficerName}</ClauseText>
              </li>
              <li>
                The loan officer phone number is{' '}
                <ClauseText>{loanOfficerPhone}</ClauseText>
              </li>
              <li>
                The loan officer email is{' '}
                <ClauseText>{loanOfficerEmail}</ClauseText>
              </li>
              <li>
                The loan officer NMLS ID is{' '}
                <ClauseText>{loanOfficerNMLS}</ClauseText>
              </li>
              <li>The Pre-Approval Letter is attached to this contract.</li>
            </ol>
          </ol>
        </ol>
      </div>
    </div>
  );
};

export default MortgageFinancing;
